import React, { useEffect } from "react";
import Data from "../../dummy";
import Detail from "./Detail";
import { useParams } from "react-router-dom";

import { fetchArticleDetail } from "../../../states/actions/fetchArticleDetail";
import { useSelector, useDispatch } from "react-redux";
import useDocumentTitle from "../../../hooks/useDocumentTitle";
import LoadingScreen from "../../common/LoadingScreen";

const ArticleDetail = (props) => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const data = useSelector((state) => state.fetchArticleDetail.content);
  const isLoading = useSelector((state) => state.fetchArticleDetail.isLoading);
  const isSiteSettingsLoading = useSelector(
    (state) => state.fetchSiteSettings.isLoading
  );
  const { article } = data;

  useEffect(() => {
    dispatch(fetchArticleDetail(id));
  }, []);

  useDocumentTitle(data.page_title);
  return (
    <>
      {isLoading || isSiteSettingsLoading ? (
        <LoadingScreen />
      ) : (
        <>
          <Detail
            data={Data.event_detail}
            show={props.popup}
            article={article}
          />
        </>
      )}
    </>
  );
};

export default ArticleDetail;
